import { ComposerState } from 'components/Composer'
import { getIsActiveConversationPermaclosed, getVisibleActiveConversationMessages } from 'modules/conversations/selectors'
import {
  isButtonsOnlyMessage,
  isEndUserMessage,
  isMeetingScheduleMessage,
  messageContainsButtons,
} from 'modules/message/utils'
import { isEmpty,last, nth } from 'ramda'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Message } from 'types/message'

const useComposerState = () => {
  const isActiveConversationPermaclosed = useSelector(getIsActiveConversationPermaclosed)
  const visibleMessages: Message[] = useSelector(getVisibleActiveConversationMessages)

  const composerState = useMemo<ComposerState>(
    () => {
      if(isActiveConversationPermaclosed) {
        return ComposerState.UNAVAILABLE
      }

      if (isEmpty(visibleMessages)) {
        return ComposerState.AVAILABLE
      }

      const latestMessage = last(visibleMessages)
      const secondToLastMessage = nth(-2, visibleMessages)

      const isLastMessageButtonsOnlyResponse = isButtonsOnlyMessage(secondToLastMessage) && isEndUserMessage(latestMessage)
      const isLatestMessageStrictCTA = (
        isButtonsOnlyMessage(latestMessage) ||
        isLastMessageButtonsOnlyResponse ||
        isMeetingScheduleMessage(latestMessage)
      )

      if (isLatestMessageStrictCTA) {
        return ComposerState.UNAVAILABLE_BUTTONS
      }

      if (messageContainsButtons(latestMessage) ||
        (messageContainsButtons(secondToLastMessage) && isEndUserMessage(latestMessage))
      ) {
        return ComposerState.AVAILABLE_BUTTONS
      }

      return ComposerState.AVAILABLE
    },
    [isActiveConversationPermaclosed, visibleMessages]
  )

  return composerState
}

export default useComposerState
